import CustomPrintConfigurationSuccess from './CustomPrintConfigurationSuccess';

export default CustomPrintConfigurationSuccess;
